export const PAYMENT_METHODS = [
  "Efectivo",
  "Deducción",
  "Transferencia",
  "Tarjeta",
  "Sin definir",
];
